module.exports = __webpack_public_path__ + "img/beian.761bc1de.jpg";